import React from 'react';
import { Monitor, RefreshCw, Plus } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

const UnconfiguredTerminalsBanner = ({
  unconfiguredTerminals,
  loadingUnconfigured,
  loadUnconfiguredTerminals,
  handleUseDetectedTerminal,
}) => {
  if (unconfiguredTerminals.length === 0) return null;

  return (
    <Card className="border-orange-900/40">
      <CardHeader className="py-3 px-5">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base flex items-center gap-2">
            <Monitor className="h-4 w-4 text-orange-500" />
            Terminaux détectés non configurés
            <Badge className="bg-orange-500 text-white ml-1">{unconfiguredTerminals.length}</Badge>
          </CardTitle>
          <Button variant="outline" size="sm" onClick={loadUnconfiguredTerminals} disabled={loadingUnconfigured}>
            <RefreshCw className={`h-3 w-3 mr-1 ${loadingUnconfigured ? 'animate-spin' : ''}`} />
            Actualiser
          </Button>
        </div>
      </CardHeader>
      <CardContent className="px-5 pb-4">
        <div className="space-y-2">
          {unconfiguredTerminals.map((terminal) => (
            <div
              key={terminal.serial_number}
              className="flex items-center justify-between bg-orange-950/20 rounded-lg p-3 border border-orange-900/40"
            >
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse" />
                <div>
                  <div className="font-medium text-foreground text-sm">{terminal.serial_number}</div>
                  <div className="text-xs text-muted-foreground">
                    IP: {terminal.ip_address} · {terminal.last_seen ? new Date(terminal.last_seen).toLocaleString('fr-FR') : ''}
                  </div>
                </div>
              </div>
              <Button
                size="sm"
                className="bg-orange-500 hover:bg-orange-600 text-white"
                onClick={() => handleUseDetectedTerminal(terminal)}
              >
                <Plus className="h-3 w-3 mr-1" /> Enregistrer
              </Button>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default UnconfiguredTerminalsBanner;
